/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import TabletEvent from '../../event/TabletEvent'

const TabletState = Record({
  uuid: ''
})

class TabletsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return []
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case TabletEvent.fetchAll:
        return payload.map(tablet => {
          return new TabletState({ uuid: tablet.uuid })
        })
      default:
        return state
    }
  }
}

export default new TabletsStore()
